/* eslint-disable */
import { Button } from "@/Components/ui/button";
import { cn } from "@/lib/utils";

const ModernTabs = ({ tabs, activeSubTab, handleSubTabChange }) => {
    return (
        <div className="flex flex-wrap divide-x divide-gray-200 border-none rounded-md overflow-hidden">
            {tabs.map((tab, index) => (
                <Button
                    key={tab.value}
                    variant={activeSubTab === tab.value ? "default" : "outline"}
                    className={cn(" rounded-none border-none text-xs bg-slate-100", activeSubTab === tab.value && "text-black bg-amber-400 hover:bg-amber-500")}
                    onClick={() => handleSubTabChange(tab.value)}
                >
                    {tab.label}
                </Button>
            ))}
        </div>
    )
}

export default ModernTabs;